import { render, staticRenderFns } from "./CoursewareTab.vue?vue&type=template&id=bc2ed31a&"
import script from "./CoursewareTab.vue?vue&type=script&lang=js&"
export * from "./CoursewareTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports